import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../utils";
export const ParkinguseStyles = makeStyles((theme) => ({
    root: {
        padding: "0px",
        backgroundColor: '#F6F6F6'
    },
    roots: {
        margin: "0px 0px 0px 4px",
        padding: "0px 4px",
    },
    image: {
        objectFit: "cover",
        width: "64px",
        borderRadius: theme.palette.borderRadius,
        height: "60px",
        border: "1px solid #5C86CB2E",
    },
    card: {
        backgroundColor: "white",
        marginTop: "12px",
        borderRadius: "4px",
        boxShadow: "0px 0px 4px #00000029",
        cursor: "pointer",
    },
    name: {
        fontSize: "0.875rem",
        fontFamily: FontFamilySwitch().bold,
        marginLeft: "12px",
        marginTop: "-8px",
    },
    total: {
        fontSize: "0.75rem",
        fontFamily: FontFamilySwitch().bold,
        color: "#071741",
        marginTop: "12px",
    },
    arrow: {
        border: "1px solid #E4E8EE",
        backgroundColor: "#F2F4F7",
        fontSize: "0.75rem",
    },
    filter: {
        borderRadius: "4px",
        border: "1px solid #E4E8EE",
        color: "black",
        backgroundColor: "white",
    },
    search: {
        "&.MuiOutlinedInput-root": {
            height: '20px !important',
            border: '1px solid #E4E8EE',
            '&:focus': {
                border: '1px solid #E4E8EE',
            }
        }
    },
    extraDetailsStyle: {
        fontSize: "0.75rem",
        color: "#4E5A6B",
    },
    verticalDividerStyle: {
        backgroundColor: "#E4E8EE",
        width: "1px",
        height: "20px",
    },
    horizontalDividerStyle: {
        backgroundColor: "#E4E8EE",
        height: "1px",
    },
    bottomCard: {
        padding: "12px",
    },
    title: {
        color: '#071741',
        fontSize: "0.875rem",
        fontFamily: FontFamilySwitch().bold,
    },
    bottomTitle: {
        fontSize: "1.125rem",
        fontFamily: FontFamilySwitch().extraBold,
    },
    titleroot: {
        borderBottom: "1px solid #c1c1c1",
        padding: "8px",
    },
    filterDrawer: {
        "& .MuiDrawer-paper": {
            width: "-webkit-fill-available",
        },
    },
    contentBottom: {
        padding: "12px",
    },
    unitImg: {
        height: "250px",
        width: "100%",
        borderRadius: "4px",
        objectFit: "cotain",
    },
    titleroot2: {
        borderBottom: "1px solid #E4E8EE",
        marginBottom: "8px",
        fontSize: "0.75rem",
        color: theme.typography.color.secondary,
        flexFlow: 'wrap !important'
    },
    phone: {
        borderRadius: "4px",
        border: "1px solid #E4E8EE",
    },
    bottomDetails: {
        fontSize: "0.875rem",
        color: theme.typography.color.primary,
        fontFamily: FontFamilySwitch().semiBold,
    },
    viewHandbook: {
        color: theme.palette.primary.main,
        fontSize: "0.875rem",
        fontFamily: FontFamilySwitch().semiBold,
        cursor: "pointer",
    },

    screenPadding: {
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
    call: {
        fontSize: "1rem",
        fontFamily: FontFamilySwitch().semiBold,
        textDecoration: "none",
        color: theme.typography.color.secondary,
    },
    callbox: {
        cursor: "pointer",
    },
    drawer: {
        "& .MuiDrawer-paper": {
            borderTopRightRadius: "4px",
            borderTopLeftRadius: "4px",
        },
        "& .MuiContainer-root": {
            padding: "0px 8px",
        },
    },
    dialog: {
        "& .MuiDialog-paper": {
            borderRadius: "4px",
            padding: "0px",
        },
    },
    bottomsub: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '10px',
        fontSize: "0.875rem"
    },
    drawermain: {
        padding: '0px 8px 0px 5px',
        backgroundColor: '#fff'
    },
    drawermain1: {
        padding: '0px 0px 0px 5px',
        backgroundColor: '#fff'
    }
}));